<script setup lang="ts">
import AddressInputComponent from "@/builder/components/textInput/AddressInputComponent.vue";
import CommentsInputComponent from "@/builder/components/textInput/CommentsInputComponent.vue";
import EmailInputComponent from "@/builder/components/textInput/EmailInputComponent.vue";
import NameInputComponent from "@/builder/components/textInput/NameInputComponent.vue";
import BusinessNameInputComponent from "@/builder/components/textInput/BusinessNameInputComponent.vue";
import PhoneNumberInputComponent from "@/builder/components/textInput/PhoneNumberInputComponent.vue";
import { ITextInputComponent, InputType } from "@/builder/components/textInput/TextInputInterface";
import { PropType } from "vue";

defineProps({
    component: {
        type: Object as PropType<ITextInputComponent>,
        required: true
    }
});
</script>

<template>
    <section class="input-container">
        <template v-if="isNaN(component.customData.type)">
            <div class="alert alert-default p-0 w-full" role="alert">
                <div class="items-center flex max-w-[90%]">
                    <i class="ri-loader-line mr-2.5" aria-hidden="true"></i>
                    <p class="!text-sm font-medium">No text input type has been selected. Pick one from the editor panel
                        to
                        get
                        started!</p>
                </div>
            </div>
        </template>
        <template v-if="component.customData.type === InputType.Name">
            <name-input-component :component="component" />
        </template>
        <template v-if="component.customData.type === InputType.BusinessName">
            <business-name-input-component :component="component" />
        </template>
        <template v-if="component.customData.type === InputType.Email">
            <email-input-component :component="component" />
        </template>
        <template v-if="component.customData.type === InputType.PhoneNumber">
            <phone-number-input-component :component="component" />
        </template>
        <template v-if="component.customData.type === InputType.Comments">
            <comments-input-component :component="component" />
        </template>
        <template v-if="component.customData.type === InputType.Address">
            <address-input-component :component="component" />
        </template>
    </section>
</template>
